import {
  PROJECT_TILE_IMAGE_FOLDER_BY_IMPACT_TYPE,
  PROJECT_TILE_IMAGE_NAME_BY_SUBTYPE,
  PROJECT_TILE_IMAGE_NAME_BY_TYPE,
  PublicProjectSummary,
} from "@ecologi/shared";
import community from "./animations/community.json";
import forest from "./animations/forest_1.json";
import turbines from "./animations/wind_turbines.json";

const IMAGE_PATH = "/images/app/forest";

type ProjectKey = NonNullable<
  PublicProjectSummary["projectType"] | PublicProjectSummary["projectSubType"]
>;

type Image = { key: ProjectKey; path: string };
type Animation = {
  key: ProjectKey;
  animation: object;
  randomStart: boolean;
};
type ImageOrAnimation =
  | ({ type: "image" } & Image)
  | ({ type: "animation" } & Animation);

const projectsWithAnimations: Animation[] = [
  {
    key: "FOREST_PROTECTION",
    animation: forest,
    randomStart: true,
  },
  {
    key: "WIND",
    animation: turbines,
    randomStart: false,
  },
  {
    key: "COMMUNITY",
    animation: community,
    randomStart: true,
  },
];

export const getImageOrAnimation = (
  project?: PublicProjectSummary
): ImageOrAnimation | null => {
  if (!project) return null;
  const key = project.projectSubType || project.projectType;

  const animation = projectsWithAnimations.find((anim) => anim.key === key);

  if (animation) {
    return {
      type: "animation",
      ...animation,
    };
  }

  const imageName = project.projectSubType
    ? PROJECT_TILE_IMAGE_NAME_BY_SUBTYPE[project.projectSubType]
    : project.projectType
    ? PROJECT_TILE_IMAGE_NAME_BY_TYPE[project.projectType]
    : undefined;

  if (imageName) {
    return {
      type: "image",
      key,
      path: `${IMAGE_PATH}/${
        PROJECT_TILE_IMAGE_FOLDER_BY_IMPACT_TYPE[project.impactType]
      }/${imageName}.svg`,
    };
  }

  return null;
};
